import React from 'react';

// 16x16 pixel-art wizard rendered as an inline SVG.
// Each character in WIZARD_PIXELS maps to a fill color ('.' = transparent).
const PIXEL_COLORS = {
  p: '#6f42c1', // hat + robe (purple)
  g: '#ffc107', // hat band, star, buttons (gold)
  f: '#f1c27d', // face
  e: '#212529', // eyes
  w: '#e9ecef', // beard
  s: '#8d5524', // staff
  o: '#0dcaf0', // staff orb
};

const WIZARD_PIXELS = [
  '........p.......',
  '.......ppp......',
  '......ppppp.....',
  '......ppgpp.....',
  '.....ppppppp....',
  '.....ppppppp....',
  '....gggggggg....',
  '.....ffffff..o..',
  '.....feffef..s..',
  '....wwffffww.s..',
  '....wwwwwwww.s..',
  '.....wwwwww..s..',
  '....pppppppp.s..',
  '...pppgppgppps..',
  '...pppppppppps..',
  '...pppppppppps..',
];

function PixelWizard({ size = 32, title = 'Wizard' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      shapeRendering="crispEdges"
      role="img"
      aria-label={title}
    >
      {WIZARD_PIXELS.flatMap((row, y) =>
        [...row].map((ch, x) =>
          ch === '.' ? null : (
            <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={PIXEL_COLORS[ch]} />
          )
        )
      )}
    </svg>
  );
}

export default PixelWizard;
